/* ניווט בין מסכים וחלונות, עם כפתור "אחורה" של הטלפון.
   כל מסך וכל חלון נרשמים בהיסטוריה של הדפדפן, כך ש"אחורה" סוגר את החלון העליון
   או חוזר למסך הקודם, במקום לצאת מהאפליקציה. */
import { notify } from '../domain/state.js';

export const PAGES = { Dash: '/', Tx: '/tx', Add: '/add', Flow: '/flow', Year: '/year', Goals: '/goals', Set: '/settings' };
const BY_PATH = Object.fromEntries(Object.entries(PAGES).map(([k, v]) => [v, k]));

export const nav = {
  page: BY_PATH[location.pathname] || 'Dash',
  stack: [], // חלונות פתוחים: { id, render }
};
let seq = 0, skipPop = 0;

export function navigate(page) {
  // חלון פתוח: הצעד שלו בהיסטוריה הופך למסך החדש, כדי ש"אחורה" לא יחזור לחלון שכבר נסגר
  const hadModal = nav.stack.length > 0;
  while (nav.stack.length) popTop();
  if (page !== nav.page || hadModal) {
    try {
      if (hadModal) history.replaceState({ page }, '', PAGES[page]);
      else history.pushState({ page }, '', PAGES[page]);
    } catch { /* ignore */ }
    nav.page = page;
  }
  window.scrollTo(0, 0);
  notify();
}

/** פותח חלון. render הוא פונקציה שמחזירה JSX, ומצוירת מחדש בכל שינוי בנתונים */
export function openModal(render, opts = {}) {
  nav.stack.push({ id: ++seq, render, onClose: opts.onClose });
  try { history.pushState({ modal: nav.stack.length, page: nav.page }, '', location.pathname); } catch { /* ignore */ }
  notify();
}
/** מחליף את החלון העליון (מעבר בתוך אותו חלון, בלי צעד בהיסטוריה) */
export function replaceModal(render) {
  if (!nav.stack.length) return openModal(render);
  const top = nav.stack[nav.stack.length - 1];
  nav.stack[nav.stack.length - 1] = { id: ++seq, render, onClose: top.onClose };
  notify();
}
function popTop() {
  const top = nav.stack.pop();
  if (top && top.onClose) top.onClose();
}
export function closeModal() {
  if (!nav.stack.length) return;
  popTop();
  skipPop++;
  try { history.back(); } catch { skipPop--; }
  notify();
}

window.addEventListener('popstate', (ev) => {
  if (skipPop > 0) { skipPop--; return; }
  if (nav.stack.length) { popTop(); notify(); return; }
  const p = (ev.state && ev.state.page) || BY_PATH[location.pathname] || 'Dash';
  nav.page = p;
  window.scrollTo(0, 0);
  notify();
});
// ה-hash נשמר: הקישור מהמייל של Supabase מעביר בו את הטוקן
try { if (!history.state) history.replaceState({ page: nav.page }, '', location.pathname + location.search + location.hash); } catch { /* ignore */ }

